(function () {
  'use strict';

  function initMobileMenu() {
    var burger = document.querySelector('.nav-burger');
    var menu = document.querySelector('.mobile-menu');
    if (!burger || !menu) return;
    burger.addEventListener('click', function () {
      var open = menu.classList.toggle('open');
      burger.classList.toggle('open', open);
      document.body.style.overflow = open ? 'hidden' : '';
      burger.setAttribute('aria-expanded', open ? 'true' : 'false');
    });
    menu.querySelectorAll('a').forEach(function (link) {
      link.addEventListener('click', function () {
        menu.classList.remove('open');
        burger.classList.remove('open');
        document.body.style.overflow = '';
      });
    });
  }

  function formatMoney(cents) {
    var amount = (cents / 100);
    var symbol = window.DRIFT9NINE && window.DRIFT9NINE.moneySymbol ? window.DRIFT9NINE.moneySymbol : '₹';
    return symbol + ' ' + amount.toLocaleString(undefined, { minimumFractionDigits: 0, maximumFractionDigits: 2 });
  }

  function refreshCartCount() {
    fetch(window.Shopify && window.Shopify.routes ? window.Shopify.routes.root + 'cart.js' : '/cart.js', {
      headers: { 'Accept': 'application/json' }
    })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        document.querySelectorAll('[data-cart-count]').forEach(function (el) {
          el.textContent = 'Bag (' + cart.item_count + ')';
        });
      })
      .catch(function () {});
  }

  function initProductForm() {
    document.querySelectorAll('[data-product-form]').forEach(function (form) {
      var variantData = [];
      var dataEl = form.querySelector('[data-product-variants]');
      try { variantData = JSON.parse(dataEl ? dataEl.textContent : '[]'); } catch (e) {}
      var idInput = form.querySelector('[name="id"]');
      var priceEl = document.querySelector('[data-product-price]');
      var compareEl = document.querySelector('[data-product-compare]');
      var atcBtn = form.querySelector('[data-atc]');
      var selects = form.querySelectorAll('[data-option-index]');

      function currentOptions() {
        var opts = [];
        selects.forEach(function (s) { opts[parseInt(s.getAttribute('data-option-index'), 10)] = s.value; });
        return opts;
      }

      function matchVariant() {
        if (!variantData.length) return null;
        var opts = currentOptions();
        return variantData.find(function (v) {
          return v.options.every(function (o, i) { return o === opts[i]; });
        }) || null;
      }

      function syncPips(group) {
        group.querySelectorAll('.variant-pip').forEach(function (pip) {
          pip.classList.toggle('active', pip.getAttribute('data-value') === group.dataset.value);
        });
      }

      function update() {
        var v = matchVariant();
        if (!v) return;
        if (idInput) idInput.value = v.id;
        if (priceEl) priceEl.textContent = formatMoney(v.price);
        if (compareEl) {
          if (v.compare_at_price && v.compare_at_price > v.price) {
            compareEl.textContent = formatMoney(v.compare_at_price);
            compareEl.style.display = '';
          } else {
            compareEl.style.display = 'none';
          }
        }
        if (atcBtn) {
          if (v.available) { atcBtn.disabled = false; atcBtn.textContent = atcBtn.getAttribute('data-label') || 'Add to Bag'; }
          else { atcBtn.disabled = true; atcBtn.textContent = 'Sold Out'; }
        }
      }

      form.querySelectorAll('[data-pip-group]').forEach(function (group) {
        group.querySelectorAll('.variant-pip').forEach(function (pip) {
          pip.addEventListener('click', function () {
            group.dataset.value = pip.getAttribute('data-value');
            var hidden = group.querySelector('input[data-option-index]') || form.querySelector('[data-option-index="' + group.getAttribute('data-option-index') + '"]');
            if (hidden) hidden.value = pip.getAttribute('data-value');
            syncPips(group);
            update();
          });
        });
      });

      selects.forEach(function (s) { s.addEventListener('change', update); });

      var qtyControl = form.querySelector('.qty-control');
      if (qtyControl) {
        var input = qtyControl.querySelector('input');
        qtyControl.querySelector('[data-qty-minus]').addEventListener('click', function () {
          input.value = Math.max(1, (parseInt(input.value, 10) || 1) - 1);
        });
        qtyControl.querySelector('[data-qty-plus]').addEventListener('click', function () {
          input.value = (parseInt(input.value, 10) || 1) + 1;
        });
      }

      update();
    });
  }

  function initAddToCartAjax() {
    document.querySelectorAll('[data-quick-add]').forEach(function (btn) {
      btn.addEventListener('click', function (e) {
        var id = btn.getAttribute('data-variant-id');
        if (!id) return;
        e.preventDefault();
        btn.textContent = 'Adding...';
        fetch((window.Shopify && window.Shopify.routes ? window.Shopify.routes.root : '/') + 'cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify({ items: [{ id: parseInt(id, 10), quantity: 1 }] })
        })
          .then(function (r) { return r.json(); })
          .then(function () { btn.textContent = 'Added ✓'; refreshCartCount(); setTimeout(function () { btn.textContent = 'Add to Bag'; }, 1600); })
          .catch(function () { btn.textContent = 'Try Again'; });
      });
    });
  }

  function initNewsletterFeedback() {
    document.querySelectorAll('[data-newsletter-form]').forEach(function (form) {
      form.addEventListener('submit', function () {
        var note = form.parentElement.querySelector('[data-newsletter-note]');
        if (note) { setTimeout(function () { note.style.display = 'block'; }, 50); }
      });
    });
  }

  function initGallery() {
    var main = document.getElementById('ProductMainImage');
    if (!main) return;
    document.querySelectorAll('[data-gallery-thumb]').forEach(function (thumb) {
      thumb.addEventListener('click', function () {
        main.src = thumb.getAttribute('data-full');
        document.querySelectorAll('[data-gallery-thumb]').forEach(function (t) { t.classList.remove('active'); });
        thumb.classList.add('active');
      });
    });
  }

  function initAnchorLinks() {
    var root = (window.Shopify && Shopify.routes && Shopify.routes.root) ? Shopify.routes.root : '/';
    var base = root.replace(/\/$/, '');

    function onHome() {
      return location.pathname === '/' || location.pathname === root || location.pathname === base;
    }

    function closeMobileMenu() {
      var menu = document.querySelector('.mobile-menu.open');
      var burger = document.querySelector('.nav-burger.open');
      if (menu) menu.classList.remove('open');
      if (burger) { burger.classList.remove('open'); burger.setAttribute('aria-expanded', 'false'); }
      document.body.style.overflow = '';
    }

    document.addEventListener('click', function (e) {
      var a = e.target.closest('a');
      if (!a) return;
      var href = a.getAttribute('href');
      if (!href) return;
      var hi = href.indexOf('#');
      if (hi === -1) return;
      var hash = href.slice(hi);
      if (hash.length < 2) return;
      var path = href.slice(0, hi);
      var isHomeAnchor = (path === '' || path === '/' || path === root || path === base);
      if (!isHomeAnchor) return;

      var target = document.querySelector(hash);
      if (target) {
        e.preventDefault();
        closeMobileMenu();
        target.scrollIntoView({ behavior: 'smooth', block: 'start' });
        if (history.replaceState) history.replaceState(null, '', hash);
      } else if (!onHome()) {
        e.preventDefault();
        window.location.href = base + '/' + hash;
      }
    });

    window.addEventListener('load', function () {
      if (location.hash && location.hash.length > 1) {
        var t = document.querySelector(location.hash);
        if (t) setTimeout(function () { t.scrollIntoView({ behavior: 'smooth', block: 'start' }); }, 120);
      }
    });
  }
function initCartPage() {
    var root = document.querySelector('[data-cart-root]');
    if (!root) return;
    var sectionId = root.getAttribute('data-section-id');
    var routeRoot = (window.Shopify && window.Shopify.routes) ? window.Shopify.routes.root : '/';

    function rerender(html) {
      try {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var fresh = doc.querySelector('[data-cart-root]');
        if (fresh) { root.innerHTML = fresh.innerHTML; }
        else { window.location.reload(); return; }
      } catch (e) { window.location.reload(); return; }
      refreshCartCount();
    }

    function changeQty(key, qty) {
      root.style.opacity = '0.5';
      root.style.pointerEvents = 'none';
      fetch(routeRoot + 'cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ id: key, quantity: qty, sections: sectionId, sections_url: '/cart' })
      })
        .then(function (r) { return r.json(); })
        .then(function (cart) {
          if (cart && cart.sections && cart.sections[sectionId]) { rerender(cart.sections[sectionId]); }
          else { window.location.reload(); }
        })
        .catch(function () { window.location.reload(); })
        .finally(function () { root.style.opacity = ''; root.style.pointerEvents = ''; });
    }

    root.addEventListener('click', function (e) {
      var btn = e.target.closest('[data-qty-change]');
      if (!btn) return;
      e.preventDefault();
      var key = btn.getAttribute('data-key');
      var qty;
      if (btn.hasAttribute('data-to')) {
        qty = parseInt(btn.getAttribute('data-to'), 10);
      } else {
        var input = root.querySelector('[data-qty-input][data-key="' + key + '"]');
        var current = input ? parseInt(input.value, 10) : 0;
        if (isNaN(current)) current = 0;
        qty = current + parseInt(btn.getAttribute('data-dir'), 10);
      }
      if (isNaN(qty) || qty < 0) qty = 0;
      changeQty(key, qty);
    });

    root.addEventListener('change', function (e) {
      var input = e.target.closest('[data-qty-input]');
      if (!input) return;
      var qty = parseInt(input.value, 10);
      if (isNaN(qty) || qty < 0) qty = 0;
      changeQty(input.getAttribute('data-key'), qty);
    });
  }
  
  document.addEventListener('DOMContentLoaded', function () {
    initMobileMenu();
    initProductForm();
    initAddToCartAjax();
    initNewsletterFeedback();
    initGallery();
    initAnchorLinks();
    initCartPage();
    refreshCartCount();
  });
})();
